import { ICloudbase } from '@cloudbase/types'
import { ICloudbaseComponent } from '@cloudbase/types/component'
import {
  CloudBaseInstance,
  generateMySQLClient,
  IMySqlOptions,
  generatePGClient,
  IPgOptions,
} from '@cloudbase/wx-cloud-client-sdk'

declare const cloudbase: ICloudbase

function getEntity(cloudbase: any & CloudBaseInstance, options: IMySqlOptions, isPg?: boolean) {
  const cloudbaseFetch = cloudbase.request.fetch.bind(cloudbase.request)
  const { instance = isPg ? undefined : 'default', database = isPg ? undefined : cloudbase.config.env } = options || {}

  // 初始化时记录 baseUrl，用于后续动态替换
  const { BASE_URL: initBaseUrl, PROTOCOL: initProtocol } = cloudbase.getEndPointWithKey('GATEWAY') as {
    BASE_URL: string
    PROTOCOL: string
  }
  const initOrigin = `${initProtocol}${initBaseUrl}`

  const fetch = async (url: RequestInfo | URL, options: RequestInit) => {
    let headers = {}
    if (options.headers instanceof Headers) {
      options.headers.forEach((value, key) => {
        headers[key] = value
      })
    } else {
      headers = options.headers || {}
    }

    [
      ['X-Db-Instance', instance],
      ['Accept-Profile', database],
      ['Content-Profile', database],
    ].forEach(([key, value]) => {
      if (!headers[key] && !headers[key.toLocaleLowerCase()] && value) {
        headers[key] = value
      }
    })

    // 动态获取最新的 GATEWAY endpoint，支持 registerEndPointWithKey 后端点变更生效
    let actualUrl = url.toString()
    const { BASE_URL: currentBaseUrl, PROTOCOL: currentProtocol } = cloudbase.getEndPointWithKey('GATEWAY') as {
      BASE_URL: string
      PROTOCOL: string
    }
    const currentOrigin = `${currentProtocol}${currentBaseUrl}`
    if (currentOrigin !== initOrigin && actualUrl.startsWith(initOrigin)) {
      actualUrl = actualUrl.replace(initOrigin, currentOrigin)
    }

    const result = await cloudbaseFetch({
      url: actualUrl,
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      shouldThrowOnError: false,
    })

    let data = {}
    try {
      data = await result.data
    } catch (e) {
      if (!e.message.includes('Unexpected end of JSON input')) {
        // 服务器会返回空字符串，导致解析失败，这时应当作正常处理
        throw e
      }
    }

    const res = {
      ok: result?.statusCode >= 200 && result?.statusCode < 300,
      status: result?.statusCode || 200,
      statusText: result?.statusMessage || 'OK',
      json: () => Promise.resolve(data || {}),
      text: () => Promise.resolve(typeof data === 'string' ? data : JSON.stringify(data || {})),
      headers: result?.header,
    }

    return res as Response
  }

  const mysqlBaseUrl = `${initProtocol}${initBaseUrl}/rdb/rest`

  const entity = isPg
    ? generatePGClient(cloudbase, {
      pgBaseUrl: mysqlBaseUrl,
      fetch,
    })
    : generateMySQLClient(cloudbase, {
      mysqlBaseUrl,
      fetch,
    })

  return entity
}

const component: ICloudbaseComponent = {
  name: 'mysql',
  entity: {
    mysql(options: IMySqlOptions) {
      return getEntity(this, options, false)(options)
    },
  },
}
const rdbComponent: ICloudbaseComponent = {
  name: 'rdb',
  entity: {
    rdb(options: IPgOptions) {
      return getEntity(this, options, true)(options)
    },
  },
}

try {
  cloudbase.registerComponent(component)
  cloudbase.registerComponent(rdbComponent)
} catch (e) {}

export function registerMySQL(app: ICloudbase) {
  try {
    app.registerComponent(component)
    app.registerComponent(rdbComponent)
  } catch (e) {
    console.warn(e)
  }
}

try {
  (window as any).registerMySQL = registerMySQL
} catch (e) {}

export * from '@cloudbase/wx-cloud-client-sdk'
